// extracted by mini-css-extract-plugin
export default {"toast":"style_toast__TL59f","toastHeader":"style_toastHeader__YM05D"};